/**
 * Formats a number to display decimal places only when needed
 * @param {number} value - The number to format
 * @returns {string} - Formatted number as a string
 *
 * @example
 * formatNumber(37.5)  // returns "37.50"
 * formatNumber(37.00) // returns "37"
 * formatNumber(37)    // returns "37"
 */
export function formatCurrency (value) {
  const num = Number(value)
  if (isNaN(num)) {
    return value
  }

  // If integer, no decimals; else, always 2 decimals
  const options = Number.isInteger(num)
    ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    : { minimumFractionDigits: 2, maximumFractionDigits: 2 }

  return new Intl.NumberFormat('en-US', options).format(num)
}